
















import Vue from "vue";
import iwInputSelect from "@/shared/components/buildingBlocks/InputSelect.vue";

export default Vue.extend({
    components: {
        iwInputSelect: iwInputSelect,
    },
    data: function() {
        return {
            pathInStore: "property.building.condition",
        };
    },
    computed: {
        buildingCondition: function(): string {
            return this.$store.getters["FormModule/getValue"](this.pathInStore);
        },
        isDisplayed: function(): boolean {
            return ["HOUSE", "APARTMENT", "COMMERCIAL", "OFFICE", "INDUSTRY","GARAGE", "OTHER"].indexOf(this.getPropertyType()) !== - 1;
        },
        options: function(): Array<Record<string, unknown>> {
            return [
                {
                    "label": this.$t("undefined"),
                    "value": ""
                },
                {
                    "label": this.$t("good"),
                    "value": "GOOD"
                },
                {
                    "label": this.$t("as_new"),
                    "value": "AS_NEW"
                },
                {
                    "label": this.$t("to_restore"),
                    "value": "TO_RESTORE"
                },
                {
                    "label": this.$t("just_renovated"),
                    "value": "JUST_RENOVATED"
                },
                {
                    "label": this.$t("to_refurbish"),
                    "value": "TO_REFURBISH"
                },
                {
                    "label": this.$t("to_renovate"),
                    "value": "TO_RENOVATE"
                }
            ];
        }
    },
    methods: {
        updateBuildingCondition: function(value: string): void {
            if (value != "") {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStore, "value": value});
            } else if (value == "" &&
                this.$store.getters["FormModule/getValue"](this.pathInStore) != null
            ) {
                this.$store.commit("FormModule/deleteValue", this.pathInStore);
            }
        }
    },

});

